import React from 'react'
import { useLanguage } from '../../../contexts/LanguageContext'

export type StockBadgeVariant = 'in_stock' | 'low_stock' | 'out_of_stock'

interface StockBadgeProps {
  quantity: number
  variant?: StockBadgeVariant
  showLabel?: boolean
  size?: 'sm' | 'md'
}

function resolveVariant(quantity: number, variant?: StockBadgeVariant): StockBadgeVariant {
  if (variant) return variant
  if (quantity <= 0) return 'out_of_stock'
  if (quantity <= 10) return 'low_stock'
  return 'in_stock'
}

const VARIANT_STYLES: Record<StockBadgeVariant, string> = {
  in_stock: 'bg-white dark:bg-gray-800 text-gray-900 dark:text-gray-100 border-gray-200 dark:border-gray-600',
  low_stock: 'bg-amber-100 dark:bg-amber-900/40 text-amber-800 dark:text-amber-200 border-amber-300 dark:border-amber-700',
  out_of_stock: 'bg-red-100 dark:bg-red-900/40 text-red-700 dark:text-red-300 border-red-300 dark:border-red-700'
}

export function StockBadge({
  quantity,
  variant,
  showLabel = false,
  size = 'sm'
}: StockBadgeProps) {
  const { t } = useLanguage()
  const resolved = resolveVariant(quantity, variant)
  const sizeClass = size === 'sm' ? 'text-xs px-2 py-0.5' : 'text-sm px-2.5 py-1'

  if (resolved === 'out_of_stock' && showLabel) {
    return (
      <span className={`inline-flex items-center font-semibold rounded-full border ${sizeClass} ${VARIANT_STYLES.out_of_stock}`}>
        {t('inhouse.outOfStock')}
      </span>
    )
  }

  return (
    <span className={`inline-flex items-center font-medium rounded-full border ${sizeClass} ${VARIANT_STYLES[resolved]}`}>
      {resolved === 'out_of_stock' ? '0' : quantity}
    </span>
  )
}
